<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Email
      @if (!loading && quote) {
        <p class="subtitle">Quote #{{quote.number}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="emailQuote()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  <ion-grid class="form">
    <ion-row>
      <ion-col>
        <ion-grid class="fieldset">
          <ion-row>
            <ion-col>
              <ion-input #to_email_address_input type="email" inputmode="email" maxlength="320" label="Email address" labelPlacement="stacked" fill="outline" [(ngModel)]="params['to_email_address']"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-input type="text" inputmode="text" maxlength="200" label="Subject" labelPlacement="stacked" fill="outline" [(ngModel)]="params['subject']"></ion-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>